import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import debouce from 'lodash.debounce';

import { getInstanceOnly } from '../lib/client';

interface UserLoginProvider {
  accountId: string;
  provider: {
    salesforce: boolean;
  };
}

export interface InitialState {
  saving: boolean;
  error: string;
  success: boolean;
  userLoginProvider: UserLoginProvider;
}

export const getUserLoginProvider = createAsyncThunk(
  'userLoginProvider/getUserLoginProvider',
  async (email: string) => {
    const instance = getInstanceOnly();
    console.log("userLoginProvider/getUserLoginProvider instance =>", instance);
    const userLoginProvider = await instance.canUserLoginWithProvider(email);
    return userLoginProvider;
  }
);

export const getUserLoginProviderDebounced = debouce((email, dispatch) => {
  if (/(.)+@(.)+/gi.test(email)) {
    dispatch(getUserLoginProvider(email));
  }
}, 300);

const initialState: InitialState = {
  saving: false,
  error: '',
  success: false,
  userLoginProvider: {
    accountId: '',
    provider: {
      salesforce: false,
    },
  },
};

const userLoginProviderSlice = createSlice({
  name: 'userLoginProviderSlice',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    // getUserConfig
    builder.addCase(getUserLoginProvider.pending, (state) => {
      state.saving = true;
      state.success = false;
      state.error = '';
    });
    builder.addCase(
      getUserLoginProvider.fulfilled,
      (state, action: PayloadAction<UserLoginProvider>) => {
        state.saving = false;
        state.success = true;
        state.error = '';
        state.userLoginProvider.accountId = action.payload.accountId;
        state.userLoginProvider.provider.salesforce =
          action.payload.provider.salesforce;
      }
    );
    builder.addCase(getUserLoginProvider.rejected, (state, action) => {
      console.error(action.error);
      state.saving = false;
      state.success = false;
      state.error = 'Unable to get user login provider';
    });
  },
});

export const { reset } = userLoginProviderSlice.actions;
export default userLoginProviderSlice;
